import gql from 'graphql-tag';
import { AFTER_SALE_FRAGMENT } from '../fragments';
import { ORDER_LINES_FRAGMENT } from '../fragments/order';

/**
 * 售后列表数据
 */
export const fetchAfterSalesListDocument = gql`
  query afterSales($options: AfterSaleListOptions, $orderCode: String, $productName: String) {
    afterSales(options: $options, orderCode: $orderCode, productName: $productName) {
      items {
        ...AfterSale
      }
      totalItems
    }
  }
  ${AFTER_SALE_FRAGMENT}
`;

/**
 * 申请售后
 */
export const fetchCreateAfterSaleDocument = gql`
  mutation createAfterSale($input: AfterSaleInput!) {
    createAfterSale(input: $input) {
      id
      order {
        id
      }
    }
  }
`;

/**
 * 更新、修改售后信息
 */
export const fetchUpdateAfterSaleDocument = gql`
  mutation updateAfterSale($input: AfterSaleInput!) {
    updateAfterSale(input: $input) {
      id
      order {
        id
      }
    }
  }
`;

/**
 * 撤销售后
 */
export const fetchCancelAfterSaleDocument = gql`
  mutation cancelAfterSale($afterSaleId: ID!) {
    cancelAfterSale(afterSaleId: $afterSaleId) {
      id
      order {
        id
      }
    }
  }
`;

/**
 * 根据订单id查询售后信息
 */
export const fetchAfterSaleByOrderIdDocument = gql`
  query afterSaleByOrderId($orderId: ID!, $options: AfterSaleListOptions = null) {
    afterSaleByOrderId(orderId: $orderId, options: $options) {
      items {
        ...AfterSale
      }
      totalItems
    }
  }
  ${AFTER_SALE_FRAGMENT}
`;

/**
 * 根据售后id查询售后信息
 */
export const fetchAfterSaleByAfterSaleIdDocument = gql`
  query afterSale($afterSaleId: ID!, $options: AfterSaleListOptions) {
    afterSale(afterSaleId: $afterSaleId, options: $options) {
      ...AfterSale
    }
  }
  ${AFTER_SALE_FRAGMENT}
`;

/**
 * 物流信息填写
 */
export const fetchFillOutReturnLogisticsDocument = gql`
  mutation fillOutReturnLogistics($input: ReturnLogisticsInput!) {
    fillOutReturnLogistics(input: $input) {
      ...AfterSale
    }
  }
  ${AFTER_SALE_FRAGMENT}
`;

/**
 * 换货确认收货
 */
export const fetchAfterSaleCustomerReceiptDocument = gql`
  mutation afterSaleCustomerReceipt($afterSaleId: ID!) {
    afterSaleCustomerReceipt(afterSaleId: $afterSaleId) {
      ...AfterSale
    }
  }
  ${AFTER_SALE_FRAGMENT}
`;

/**
 * 修改物流
 */
export const fetchUpdateReturnLogisticsDocument = gql`
  mutation updateReturnLogistics($input: ReturnLogisticsInput!) {
    updateReturnLogistics(input: $input) {
      ...AfterSale
    }
  }
  ${AFTER_SALE_FRAGMENT}
`;

/**
 * 获取最大可退款金额
 */
export const fetchGetRefundableAmountDocument = gql`
  query getRefundableAmount(
    $orderId: ID!
    $lineIds: [ID]
    $isInclusionShippingPrice: Boolean
    $isUpdate: Boolean
  ) {
    getRefundableAmount(
      orderId: $orderId
      lineIds: $lineIds
      isInclusionShippingPrice: $isInclusionShippingPrice
      isUpdate: $isUpdate
    )
  }
`;

// 获取每个商品售后可退的金额
export const fetchCommdityGetRefundableAmountDocument = gql`
  query getRefundableAmountByOrderId($orderId: ID!) {
    getRefundableAmountByOrderId(orderId: $orderId) {
      orderLine {
        ...OrderLine
      }
      refundableAmount
      isAllowAfterSale
    }
  }
  ${ORDER_LINES_FRAGMENT}
`;

/**
 * 获取购物金抵扣和返还金额
 */
export const fetchShoppingCreditsClaimAndDeductionAmountDocument = gql`
  query shoppingCreditsClaimAndDeductionAmount($orderId: ID!) {
    shoppingCreditsClaimAndDeductionAmount(orderId: $orderId) {
      orderLineId
      shoppingCreditsClaimAmount
      shoppingCreditsDeductionAmount
    }
  }
`;
